<template>
    <div>
        <myHeader></myHeader>
        <aboutNav></aboutNav>
        <div class="view_wrap">
            <div class="view_ul">
                <div class="view_li" v-for="(item,index) in viedoList" :key="index" @click="li_video(item.video_link)">
                    <b>
                        <img :src="item.thumb" alt="">
                        <strong></strong>
                        <i></i>
                    </b>
                    <span>{{item.name}}</span>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
        <el-dialog :visible.sync="dialogVisible" width="1120px" height="630px" :show-close="false">
            <video
                   ref="videos"
                   class="tsgz-video"
                   controls="controls"
                   :src="video_mp4"
                   autoplay
                   type="video/mp4"
                   muted
                   @ended="playNextVideo()">
                Your browser does not support video tags.
            </video>
        </el-dialog>
    </div>
</template>

<script>
import myHeader from '../../components/header.vue'
import MyFooter from '../../components/footer.vue'
import aboutNav from '../../components/about_nav.vue'
export default {
    name: 'about_view',
    components: {MyFooter, myHeader,aboutNav},
    data () {
        return {
            dialogVisible:false,
            video_mp4:'../../../static/images/mascot.mp4',
            viedoList:[]
        }
    },
    created () {
        this.pageData();
    },
    methods: {
        pageData () {
            let params = {
                page:1,
                page_size:1000
            };
            this.$api.videoList(params).then(res => {
                this.viedoList = res.data;
            });
        },
        li_video(video_link){
            this.video_mp4 = video_link;
            this.dialogVisible = true;
        },
        carouselChange(index) {
            const videos = this.$refs.videos;
            videos.forEach((video) => {
                video.currentTime = 0; // 将视频回到起始时间
                video.pause(); // 暂停视频播放
            });
            videos[index].play();
        },
        playNextVideo(index) {
            const videos = this.$refs.videos;
            let nextIndex = index;
            if (index < this.vidData.length - 1) {
                nextIndex = nextIndex + 1;
            } else {
                nextIndex = 0;
            }
            const carousel = this.$refs.carousel;
            carousel.setActiveItem(nextIndex);
            const nextVideo = videos[nextIndex];
            videos.forEach((video) => {
                video.pause();
                video.currentTime = 0;
            });
            setTimeout(() => {
                nextVideo.play();
            }, 1000);
        },
        nextClick(){
            this.page++;
            this.pageNews();
        },
        prevClick(){
            this.page--;
            this.pageNews();
        },
        handleCurrentChange(val){
            this.page=val;
            this.pageNews();
        },
    }
}
</script>

<style scoped>
.view_wrap{width:100%;height:auto;min-height:200px;float:left;padding:50px 0 60px;}
.view_ul{width:1200px;height:auto;min-height:200px;position:relative;left:50%;margin-left:-600px;float:left;margin-top:0;}
.view_ul .view_li{width:390px;height:260px;display:inline-block;float:left;margin-left:15px;margin-top:15px;overflow:hidden;cursor:pointer;}
.view_ul .view_li:nth-child(3n-2){margin-left:0;}
.view_ul .view_li:nth-child(1){margin-top:0;}
.view_ul .view_li:nth-child(2){margin-top:0;}
.view_ul .view_li:nth-child(3){margin-top:0;}
.view_ul .view_li b{width:390px;height:220px;display:block;float:left;overflow:hidden;position:relative;}
.view_ul .view_li b strong{width:100%;height:220px;display:block;background:#000;opacity:0.5;position:absolute;left:0;top:0;z-index:10;}
.view_ul .view_li b i{width:48px;height:48px;background:url(../../../static/images/pay_icon.png) center no-repeat;background-size:48px 48px;
    position:absolute;left:50%;margin-left:-24px;top:50%;margin-top:-24px;display:block;z-index:88;}
.view_ul .view_li img{width:100%;height:auto;display:block;}
.view_ul .view_li span{width:100%;height:40px;display:block;float:left;font-size:16px;color:#333;line-height:40px;
    text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.tsgz-video{width:auto;height:100%;display:block;margin:0 auto;}
/deep/ .el-dialog{background:transparent;}
/deep/ .el-dialog__body{padding:0 !important;width:1120px !important;;height:630px !important;}
/deep/ .el-dialog__header{padding:0 !important;}
@media (min-width:992px) and (max-width:1200px){
    .view_wrap{min-height:200px;padding:40px 0 50px;}
    .view_ul{width:1000px;min-height:200px;margin-left:-500px;}
    .view_ul .view_li{width:324px;height:256px;margin-left:14px;margin-top:14px;}
    .view_ul .view_li:nth-child(3n-2){margin-left:0;}
    .view_ul .view_li:nth-child(1){margin-top:0;}
    .view_ul .view_li:nth-child(2){margin-top:0;}
    .view_ul .view_li:nth-child(3){margin-top:0;}
    .view_ul .view_li b{width:324px;height:220px;}
    .view_ul .view_li b strong{height:220px;}
    .view_ul .view_li b i{width:40px;height:40px;background:url(../../../static/images/pay_icon.png) center no-repeat;background-size:40px 40px;
        margin-left:-20px;margin-top:-20px;}
    .view_ul .view_li span{height:36px;font-size:15px;line-height:36px;}
}
@media (min-width:768px) and (max-width:991px){
    .view_wrap{min-height:200px;padding:30px 0 40px;}
    .view_ul{width:750px;min-height:200px;margin-left:-375px;}
    .view_ul .view_li{width:242px;height:190px;margin-left:12px;margin-top:12px;}
    .view_ul .view_li:nth-child(3n-2){margin-left:0;}
    .view_ul .view_li:nth-child(1){margin-top:0;}
    .view_ul .view_li:nth-child(2){margin-top:0;}
    .view_ul .view_li:nth-child(3){margin-top:0;}
    .view_ul .view_li b{width:242px;height:160px;}
    .view_ul .view_li b strong{height:160px;}
    .view_ul .view_li b i{width:36px;height:36px;background:url(../../../static/images/pay_icon.png) center no-repeat;background-size:36px 36px;
        margin-left:-18px;margin-top:-18px;}
    .view_ul .view_li span{height:30px;font-size:15px;line-height:30px;}
}
@media (max-width:767px){
    .view_wrap{min-height:200px;padding:20px 15px 30px;}
    .view_ul{width:100%;min-height:200px;margin-left:0;left:0;}
    .view_ul .view_li{width:100%;height:auto;margin-left:0;margin-top:10px;}
    .view_ul .view_li:nth-child(3n-2){margin-left:0;}
    .view_ul .view_li:nth-child(1){margin-top:0;}
    .view_ul .view_li:nth-child(2){margin-top:10px;}
    .view_ul .view_li:nth-child(3){margin-top:10px;}
    .view_ul .view_li b{width:100%;height:auto;max-height:180px;}
    .view_ul .view_li b strong{height:auto;}
    .view_ul .view_li b i{width:36px;height:36px;background:url(../../../static/images/pay_icon.png) center no-repeat;background-size:36px 36px;
        margin-left:-18px;margin-top:-18px;}
    .view_ul .view_li span{height:30px;font-size:14px;line-height:30px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about_view.vue